module.exports = __webpack_public_path__ + "static/media/HOME-image1.2141abea.png";